// UserSettingsModalContent.tsx
import React from "react";
import { Stack } from "@mantine/core";
import { FailedAlert, MCLoader } from "../../components";
import UpdateUserNameCard from "./UpdateUserProfileCard";
import ApiKeyPanel from "./UserApiKeyPanel";
import { useGetWhoamiQuery } from "../../../openapi";

const UserSettingsModalContent: React.FC = () => {
  const { data, isLoading, isError } = useGetWhoamiQuery();

  if (isLoading) return <MCLoader />;
  if (isError) return <FailedAlert />;
  if (!data) return null;

  return (
    <Stack gap="lg">
      <UpdateUserNameCard />
      <ApiKeyPanel />
    </Stack>
  );
};

export default UserSettingsModalContent;
